// import type
import { ROLE_DATA } from './type'

export const role = (data, dispatch) => {
  dispatch({
    type: ROLE_DATA,
    role: {
      role: data.role,
      restriction: data.restriction,
      adminId: data.id,
      adminName: data.name,
      twoFAStatus: data.twoFAStatus,
      members:data.members,
      agentId:data.agentId,
      managerId:data.managerId,
      savedFilter: data.savedFilter
    },
  })
}
